import React, { useRef, forwardRef } from 'react';
import PropTypes from 'prop-types';

import { bem } from 'helpers/class-name';
import Message from 'components/Message';

import messages from './Dropdown.messages';
import './DropdownItemCheckbox.scss';

const { block, element } = bem('dropdown-item2-checkbox');

const DropdownItemCheckboxWrapper = forwardRef(function DropdownItemCheckbox(props, ref) {
  const { children, className, disabled, isChecked, isHighlighted, isSelectAll, isWrapping, onClick, onSelect } = props;

  let labelRef = useRef();
  if (ref) {
    labelRef = ref;
  }

  function handleChange(event) {
    event.stopPropagation();
    onClick(event.target.checked);
    if (onSelect) onSelect();
  }

  return (
    <label ref={labelRef} className={block(className, { disabled, isHighlighted, isWrapping })}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        disabled={disabled}
        className={element('checkbox', { disabled, isWrapping })}
      />
      <div className={element('content', { isWrapping })}>
        {isSelectAll ? <Message message={messages.selectAll} /> : children}
      </div>
    </label>
  );
});

DropdownItemCheckboxWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isChecked: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  isSelectAll: PropTypes.bool,
  isWrapping: PropTypes.bool,
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
};

export default DropdownItemCheckboxWrapper;
